import { useState } from 'react'
import { Button, Group, Paper, Stack, Text, Textarea, Title } from '@mantine/core'

// #1122 応募詳細(/applications/:id)の辞退操作。expert 本人にのみ表示され(show.html.erb 側で判定)、
// Rails の form_with(POST /applications/:id/withdraw)の内側に置き、name="reason" の textarea を通常のフォーム送信に乗せる。
// Mantine の Modal はフローティング系で描画されない可能性がある(see memory: mantine_v9_broken_components)ため、
// ボタン押下でその場に展開するインライン確認パネルにしている。
// 理由(reason)は自由文・任意で、Bizlink admin だけが見る内部メモ(job_application_status_changes.note)に入る。
// 非媒介(docs/application-tracking.md §2): 企業には一切渡らないことを、このパネル内の注記で明示する。
export default function JobApplicationWithdrawButton() {
  const [expanded, setExpanded] = useState(false)

  if (!expanded) {
    // 辞退ボタンは画面下部の単独操作なので中央に置く(#1217)。展開後の確認パネル内のボタンは通常のフォーム同様に右寄せ
    return (
      <Group justify="center">
        <Button type="button" color="red" variant="outline" onClick={() => setExpanded(true)}>
          応募を辞退する
        </Button>
      </Group>
    )
  }

  return (
    <Paper withBorder p="md">
      <Stack gap="md">
        <Title order={3} fz="h4">この応募を辞退しますか？</Title>

        <Textarea
          name="reason"
          label="辞退理由（任意）"
          description="Bizlink 担当者のみが確認します。企業には送られません。"
          placeholder="任意"
          autosize
          minRows={3}
          maxRows={8}
        />

        <Group justify="flex-end">
          <Button type="button" variant="default" onClick={() => setExpanded(false)}>
            キャンセル
          </Button>
          <Button type="submit" color="red">
            辞退を確定する
          </Button>
        </Group>
      </Stack>
    </Paper>
  )
}
